import moment from 'moment'

export default function () {
  const prefix = 'A'
  return prefix + moment().utc().format('YYYYMMDDhhmmss')
}



// WEBPACK FOOTER //
// ./src/utils/helpers/DataEntryViews/AutoNumber.js